import LocationAddPage from './add'
export default LocationAddPage
